import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'onefaceui-react-components';
import { v4 as uuid } from 'uuid';
import FilledChevronDown from 'static/images/general/filled-chevron.svg';
import StatusCaptionItem from './StatusCaptionItem';

function StatusCaption({
  options,
  onOptionClick,
  toggleLabel,
  afterHandleToggle
}) {
  const [isOpen, setIsOpen] = useState(false);

  function handleToggleSection() {
    setIsOpen(!isOpen);
    afterHandleToggle(!isOpen);
  }

  return (
    <Flex
      data-testid="status-caption"
      className="status-caption"
      alignItems="center"
      gap={16}
    >
      <Text size="xs">{toggleLabel}</Text>
      <Flex
        className="list-caption"
        shouldShow={isOpen}
        alignItems="center"
        gap={12}
      >
        {options.map(
          ({
            type,
            title,
            captionItemLabelClassname,
            unchecked,
            captionItemLabelStyle,
            children
          }) => (
            <StatusCaptionItem
              key={uuid()}
              type={type}
              title={title}
              captionItemLabelClassname={captionItemLabelClassname}
              captionItemLabelStyle={captionItemLabelStyle}
              onClick={() => onOptionClick(type)}
              unchecked={unchecked}
            >
              {children}
            </StatusCaptionItem>
          )
        )}
      </Flex>
      <button
        type="button"
        onClick={handleToggleSection}
        className={isOpen ? 'opened' : 'closed'}
        data-testid="toggle-btn"
      >
        <img src={FilledChevronDown} alt="Chevron icon" />
      </button>
    </Flex>
  );
}

StatusCaption.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      captionItemLabelClassname: PropTypes.string,
      captionItemLabelStyle: PropTypes.shape({})
    })
  ),
  onOptionClick: PropTypes.func,
  afterHandleToggle: PropTypes.func,
  toggleLabel: PropTypes.string
};

StatusCaption.defaultProps = {
  options: [],
  onOptionClick: () => {},
  afterHandleToggle: () => {},
  toggleLabel: ''
};

export default memo(StatusCaption);
